export default __webpack_public_path__ + "static/media/287.dec43c0e.jpg";